// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.wt-tenant-app {
  background: color-mix(in srgb, var(--tenant-surface, #fff) 32%, #fff);
  font-family: var(--tenant-font, inherit);
}

body.wt-tenant-app .navbar-default {
  border-bottom-color: var(--tenant-primary, #337ab7);
  box-shadow: 0 2px 0 color-mix(in srgb, var(--tenant-primary, #337ab7) 18%, transparent);
}

body.wt-tenant-app .navbar-brand-label,
body.wt-tenant-app .navbar-default .navbar-nav > li > a:hover,
body.wt-tenant-app .navbar-default .navbar-nav > li > a:focus {
  color: var(--tenant-primary, #337ab7);
}

body.wt-tenant-app .jumbotron {
  border-top: 4px solid var(--tenant-primary, #337ab7);
  background: linear-gradient(135deg, var(--tenant-surface, #f5f5f5), #fff 72%);
}

body.wt-tenant-app .wt-btn-explore {
  border-color: var(--tenant-primary, #337ab7);
  background-color: var(--tenant-primary, #337ab7);
}

body.wt-tenant-app .wt-btn-explore:hover,
body.wt-tenant-app .wt-btn-explore:focus {
  filter: brightness(0.92);
}

body.wt-tenant-app .footer {
  border-top-color: var(--tenant-accent, #ddd);
}

[data-theme='dark'] body.wt-tenant-app {
  background: color-mix(in srgb, var(--tenant-primary, #337ab7) 8%, var(--wt-page));
}

[data-theme='dark'] body.wt-tenant-app .navbar-default {
  background-color: var(--wt-navbar);
}

[data-theme='dark'] body.wt-tenant-app .jumbotron {
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--tenant-primary, #337ab7) 12%, var(--wt-surface-muted)),
    var(--wt-surface) 72%
  );
}
`, "",{"version":3,"sources":["webpack://./client/src/styles/tenant-shell.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;EACrE,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,uFAAuF;AACzF;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,oDAAoD;EACpD,6EAA6E;AAC/E;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD;AAClD;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;;;;GAIC;AACH","sourcesContent":["body.wt-tenant-app {\n  background: color-mix(in srgb, var(--tenant-surface, #fff) 32%, #fff);\n  font-family: var(--tenant-font, inherit);\n}\n\nbody.wt-tenant-app .navbar-default {\n  border-bottom-color: var(--tenant-primary, #337ab7);\n  box-shadow: 0 2px 0 color-mix(in srgb, var(--tenant-primary, #337ab7) 18%, transparent);\n}\n\nbody.wt-tenant-app .navbar-brand-label,\nbody.wt-tenant-app .navbar-default .navbar-nav > li > a:hover,\nbody.wt-tenant-app .navbar-default .navbar-nav > li > a:focus {\n  color: var(--tenant-primary, #337ab7);\n}\n\nbody.wt-tenant-app .jumbotron {\n  border-top: 4px solid var(--tenant-primary, #337ab7);\n  background: linear-gradient(135deg, var(--tenant-surface, #f5f5f5), #fff 72%);\n}\n\nbody.wt-tenant-app .wt-btn-explore {\n  border-color: var(--tenant-primary, #337ab7);\n  background-color: var(--tenant-primary, #337ab7);\n}\n\nbody.wt-tenant-app .wt-btn-explore:hover,\nbody.wt-tenant-app .wt-btn-explore:focus {\n  filter: brightness(0.92);\n}\n\nbody.wt-tenant-app .footer {\n  border-top-color: var(--tenant-accent, #ddd);\n}\n\n[data-theme='dark'] body.wt-tenant-app {\n  background: color-mix(in srgb, var(--tenant-primary, #337ab7) 8%, var(--wt-page));\n}\n\n[data-theme='dark'] body.wt-tenant-app .navbar-default {\n  background-color: var(--wt-navbar);\n}\n\n[data-theme='dark'] body.wt-tenant-app .jumbotron {\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--tenant-primary, #337ab7) 12%, var(--wt-surface-muted)),\n    var(--wt-surface) 72%\n  );\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
